module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mousedown": _vm.mouseDown,
      "mouseup": _vm.mouseUp,
      "mousemove": _vm.mouseMove
    }
  }, [_c('navigation', {
    ref: "navigation"
  }), _vm._v(" "), _c('main', [_c('main-header', [_c('div', {
    class: ['account', _vm.hasMultipleAccounts() ? 'multiple' : '']
  }, [(_vm.hasMultipleAccounts()) ? _c('icon', {
    attrs: {
      "name": "arrow-down"
    }
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.current.account.name) + "\n                "), (_vm.hasMultipleAccounts()) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAccount]
    }
  }, _vm._l((_vm.current.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v(_vm._s(account.name))])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.viewport == 'd') ? _c('router-link', {
    attrs: {
      "to": _vm.$onduro.route('profile')
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.current.user.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.current.user.demo) ? _c('a', {
    staticClass: "help",
    on: {
      "click": function($event) {
        return _vm.showHelp()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('text.help')))]) : _vm._e(), _vm._v(" "), (_vm.hasUniversity) ? _c('a', {
    class: ['box-university', _vm.$store.state.current.account.demo ? 'btn btn--orange' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleUniversity
    }
  }, [_vm._v("University")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn logout",
    attrs: {
      "to": _vm.$onduro.route('logout')
    }
  }, [(_vm.viewport == 'mp' || _vm.viewport == 'ml') ? _c('icon', {
    attrs: {
      "name": "logout"
    }
  }) : _c('span', [_vm._v("Logout")])], 1)], 1)]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce49dc76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/templates/Backend.vue
// module id = 487
// module chunks = 234